import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// import { getImageUrl } from 'utils/imageUrl';

import Wrapper from './styled/Wrapper';
import ImageDiv from './styled/ImageDiv';

export default class Img extends PureComponent {
  static defaultProps = {
    backgroundColor: '#cdf4f2',
    scaleMode: 'cover',
    position: '50% 50%',
  };

  state = {
    isLoaded: false,
  };

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    const { src } = this.props;

    if (src !== prevProps.src) {
      this.loadImage();
    }
  }

  loadImage() {
    const { src } = this.props;

    this.setState({ isLoaded: false });
    const image = new Image();
    // image.crossOrigin = 'anonymous';
    image.addEventListener('load', this.onImageLoadComplete, { once: true });

    image.src = src;
  }

  onImageLoadComplete = () => {
    this.setState({ isLoaded: true });
  };

  render() {
    const { className, scrollRef, scaleMode, position, backgroundColor, src } =
      this.props;
    const { isLoaded } = this.state;

    return (
      <Wrapper
        className={className}
        ref={scrollRef}
        backgroundColor={backgroundColor}
      >
        <ImageDiv
          scaleMode={scaleMode}
          position={'center'}
          src={src}
          hidden={!isLoaded}
        />
      </Wrapper>
    );
  }
}
